var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pic-word-one" },
    [
      _c("img", {
        staticClass: "corver-img",
        attrs: { src: _vm.info.bigPic ? _vm.info.bigPic : _vm.info.picUrl }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "corver-body" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.info.title))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "desc" }, [
          _vm._v(_vm._s(_vm.info.description))
        ])
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }